import {AxiosInstance} from "axios";
import Tag from "../model/tag/Tag";

/**
 * Api for tags.
 */
export default class TagApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Get tags.
	 * @return {Promise<Tag[]>} Promise with tags.
	 */
	fetchTags(): Promise<Tag[]> {
		const url = '/api/web/leads/tags';
		return this.axiosInstance.get(url).then(resp => resp.data.map(Tag.fromJson))
	}

	/**
	 * Get job tags.
	 * @returns {Promise<Tag[]>}
	 */
	fetchJobTags(): Promise<Tag[]> {
		const url = '/api/web/jobs/tags';
		return this.axiosInstance.get(url).then(resp => resp.data.map(Tag.fromJson))
	}
}